const lang = {
  en: {
    search: "Search",
    placeHolder: "What would you like to wtch today?",
  },
  hindi: {
    search: "खोज",
    placeHolder: "आज आप क्या देखना चाहेंगे?",
  },
  telugu: {
    search: "వెతకండి",
    placeHolder: "మీరు ఈరోజు ఏమి చూడాలనుకుంటున్నారు?",
  },
  spanish: {
    search: "buscar",
    placeHolder: "¿Qué te gustaría ver hoy?",
  },
};

export default lang;